export const guides = [
  {
    slug: "zadatek-przed-zakupem-mieszkania",
    title: "Zadatek za mieszkanie: co sprawdzić przed wpłatą?",
    description: "Połącz budżet, dokumenty mieszkania i terminy umowy, zanim wpłacisz pieniądze sprzedającemu.",
    topic: "zakup-wtorny", icon: "home",
    answer: "Przed wpłatą sprawdź, czy plan zakupu pasuje do Twoich możliwości finansowych, dokumentów nieruchomości i terminów płatności. Wstępna analiza finansowania pomaga ustalić plan, ale nie zastępuje decyzji banku. Warunki wpłaty i jej rozliczenia powinny wynikać z umowy.",
    sections: [
      { title: "Zacznij od pełnego budżetu", text: "Oprócz ceny mieszkania uwzględnij koszty zakupu, ewentualnego pośrednika, remontu i rezerwę po przeprowadzce. Środki, które wpłacisz wcześniej, przestają być dostępne na inne wydatki.", items: ["Ile pieniędzy możesz przeznaczyć na wkład i koszty, pozostawiając rezerwę?", "Czy dochód i obecne zobowiązania pozwalają na planowaną ratę?", "Czy cena i stan mieszkania pasują do planowanej kwoty kredytu?"] },
      { title: "Sprawdź dokumenty i ustal terminy", text: "Ustal ze sprzedającym, jakie dokumenty będą potrzebne do analizy bankowej, kiedy je otrzymasz i jak zostaną rozliczone ewentualne obciążenia nieruchomości. Sam termin podpisania aktu nie wyjaśnia jeszcze terminu zapłaty z kredytu.", items: ["Sprawdź księgę wieczystą oraz podstawę nabycia nieruchomości przez sprzedającego.", "Ustal kwotę, charakter i sposób rozliczenia wpłaty oraz terminy dalszych płatności.", "Omów, co przewiduje umowa przy opóźnieniu lub braku finansowania. Zapisy prawne skonsultuj z notariuszem lub prawnikiem."] },
    ],
    example: { title: "Mieszkanie za 500 000 zł: ile pieniędzy przygotować?", text: "Załóżmy, że bank wymaga 50 000 zł Twojego wkładu. Do tego planujesz koszty zakupu i rezerwę:", rows: [["Wkład własny", "50 000 zł"], ["Przykładowe koszty zakupu", "15 000 zł"], ["Rezerwa na wydatki po zakupie", "20 000 zł"], ["Razem własne środki", "85 000 zł"]], takeaway: "50 000 zł wkładu nie wystarczy na cały plan. Koszty i rezerwa są dodatkowymi wydatkami. Kwoty kosztów są przykładowe." },
    prepare: "Cena mieszkania, dostępne środki, planowane terminy i podstawowe informacje o dochodach. Nie musisz mieć jeszcze wszystkich dokumentów.",
    cta: "Porozmawiajmy o Twoim kredycie", help: "Uporządkujemy możliwości finansowania i wymagania banków, zanim ustalisz kolejne płatności.",
    tools: [{ label: "Policz ratę i wkład", href: "/kalkulator-rata-wklad" }, { label: "Otwórz checklistę zakupu", href: "/checklisty" }],
    faqs: [{ q: "Czy analiza zdolności daje pewność uzyskania kredytu?", a: "Nie. Ostateczna decyzja uwzględnia również dokumenty, nieruchomość i warunki konkretnego banku." }, { q: "Czy zadatek i zaliczka oznaczają to samo?", a: "Nie traktuj tych nazw zamiennie. Sposób rozliczenia wpłaty i skutki niewykonania umowy trzeba omówić przed podpisaniem, uwzględniając treść umowy i okoliczności transakcji." }],
  },
  {
    slug: "deweloper-kredyt-terminy-platnosci", title: "Zakup od dewelopera: jak połączyć kredyt z terminami płatności?",
    description: "Ułóż harmonogram wpłat, dokumentów i finansowania, zanim przyjmiesz termin płatności za mieszkanie.",
    topic: "zakup-deweloper", icon: "home",
    answer: "Zestaw harmonogram dewelopera z planem wykorzystania własnych środków i wypłat kredytu. Odróżnij termin decyzji, podpisania umowy bankowej i faktycznej wypłaty pieniędzy. Każdy z tych etapów wymaga przygotowania.",
    sections: [
      { title: "Zapisz każdą płatność na jednej osi czasu", text: "Dla każdej wpłaty określ kwotę, termin, źródło pieniędzy i wymagany dokument. Uwzględnij również płatności za dodatkowe elementy zakupu i wykończenie, jeżeli są częścią Twojego planu.", items: ["Sprawdź, ile trzeba zapłacić przed uruchomieniem finansowania.", "Ustal, które płatności pokryjesz samodzielnie, a które z kredytu.", "Oddziel odbiór mieszkania, przeniesienie własności i termin rozliczenia ceny."] },
      { title: "Przed podpisaniem uzgodnij wykonalny plan", text: "Nie zakładaj, że bank wypłaci pieniądze od razu po decyzji. Poproś o wyjaśnienie warunków uruchomienia i dokumentów dotyczących inwestycji. Gdy termin płatności jest bliski, zacznij od ustalenia realnych możliwości, zamiast opierać się na orientacyjnym czasie obsługi.", items: ["Zbierz dokumenty inwestycji i harmonogram od dewelopera.", "Sprawdź wymagania wybranego banku dotyczące wkładu i wypłat.", "Ustal sposób postępowania, jeżeli płatność lub dokumenty się opóźnią. Treść umowy omów z właściwym specjalistą."] },
    ],
    example: { title: "Deweloper oczekuje trzech wpłat", text: "Mieszkanie kosztuje 600 000 zł. Planujesz 60 000 zł własnych środków i 540 000 zł kredytu.", rows: [["Pierwsza wpłata z Twoich środków", "60 000 zł"], ["Druga wpłata z kredytu", "180 000 zł"], ["Ostatnia wpłata z kredytu", "360 000 zł"]], takeaway: "Przed terminem drugiej wpłaty trzeba mieć nie tylko decyzję, lecz także spełnione warunki wypłaty kredytu. Podział wpłat musi zaakceptować bank." },
    prepare: "Cena, harmonogram płatności, planowana kwota własnych środków i termin odbioru lub przeniesienia własności.", cta: "Omów terminy zakupu", help: "Połączymy harmonogram zakupu z dokumentami i warunkami uruchomienia kredytu.",
    tools: [{ label: "Policz ratę i wkład", href: "/kalkulator-rata-wklad" }, { label: "Otwórz checklistę dewelopera", href: "/checklisty" }],
    faqs: [{ q: "Czy odbiór mieszkania oznacza, że bank wypłaci kredyt?", a: "Nie automatycznie. Wypłata zależy od warunków umowy kredytowej i wymaganych dokumentów." }, { q: "Kiedy zacząć przygotowanie finansowania?", a: "Przed zobowiązaniem się do konkretnych płatności. Jeżeli umowa jest już podpisana, punktem wyjścia jest najbliższy termin i dostępne dokumenty." }],
  },
  {
    slug: "budowa-domu-budzet-i-transze", title: "Budowa domu: jak zaplanować budżet i wypłaty transz?",
    description: "Sprawdź, czy środki wystarczą pomiędzy etapami budowy i warunkami wypłaty kolejnych transz.",
    topic: "budowa", icon: "build",
    answer: "Budżet budowy powinien pokazywać nie tylko łączny koszt, lecz także moment, w którym potrzebujesz pieniędzy. Dopasuj etapy, własne środki i transze do kosztorysu akceptowanego przez bank. Oddziel rezerwę na zmiany od pieniędzy potrzebnych do zakończenia bieżącego etapu.",
    sections: [
      { title: "Podziel kosztorys na etapy", text: "Zapisz zakres prac, koszt materiałów i robocizny oraz termin płatności wykonawcom. Określ standard, do którego zamierzasz doprowadzić dom. Oferty wykonawców powinny wyjaśniać, co obejmuje cena, aby nie pominąć instalacji, przyłączy lub wykończenia.", items: ["Rozdziel wydatki już poniesione od prac, które dopiero sfinansujesz.", "Sprawdź, jakie własne środki i wartość działki bank może uwzględnić w Twoim planie.", "Zaplanuj rezerwę oraz wariant postępowania przy wzroście kosztów."] },
      { title: "Czy wystarczy pieniędzy na kolejny etap?", text: "Warunki rozliczenia etapu i wypłaty następnej transzy określa bank. Ustal je przed uzgodnieniem płatności z wykonawcą. Dopasuj harmonogram do wymaganych potwierdzeń postępu prac i dostępnych pieniędzy.", items: ["Jakie prace muszą być gotowe przed kolejną wypłatą?", "Jak bank potwierdza wykonanie etapu i czy wiąże się to z dodatkowym kosztem?", "Czy możesz zapłacić wykonawcy, jeżeli kolejna transza nie została jeszcze uruchomiona?"] },
    ],
    example: { title: "Na etap budowy brakuje 30 000 zł", text: "Bank wypłaci następną transzę dopiero po zakończeniu wymaganego etapu. Sprawdź środki dostępne już teraz:", rows: [["Własna gotówka", "80 000 zł"], ["Wypłacona transza", "100 000 zł"], ["Razem dostępne", "180 000 zł"], ["Koszt ukończenia etapu", "210 000 zł"], ["Brakująca kwota", "30 000 zł"]], takeaway: "Pieniędzy z następnej transzy nie możesz wydać wcześniej. Zanim ruszysz z pracami, uzgodnij z bankiem wykonalny podział etapów i zaplanuj brakujące środki." },
    prepare: "Projekt, kosztorys lub oferty wykonawców, informacje o działce, wykonanych pracach i dostępnych środkach.", cta: "Omów kosztorys i transze", help: "Sprawdzimy, jak połączyć kosztorys z planem własnych środków i wymaganiami banków.",
    tools: [{ label: "Policz orientacyjną ratę", href: "/kalkulator-rata-wklad" }, { label: "Otwórz checklistę budowy", href: "/checklisty" }],
    faqs: [{ q: "Czy jeden koszt budowy za metr wystarczy do planu?", a: "Nie. Standard domu, zakres prac i lokalne oferty wykonawców mogą się różnić. Potrzebujesz kosztorysu swojej inwestycji i warunków konkretnego banku." }, { q: "Czy działka zastępuje wszystkie środki na budowę?", a: "Wartość działki może być istotna dla wkładu i zabezpieczenia, ale sama nie zapewnia gotówki na materiały i wykonawców." }],
  },
  {
    slug: "rkm-ile-wlasnych-pieniedzy", title: "RKM: ile własnych pieniędzy potrzebujesz na zakup?",
    description: "Odróżnij gwarancję BGK od gotówki, kosztów zakupu i rezerwy potrzebnej przy transakcji.",
    topic: "rkm", icon: "wallet",
    answer: "Gwarancja BGK zabezpiecza część kredytu, a nie wypłaca Ci pieniędzy. RKM może być udzielony z gwarancją lub bez niej. Własne środki nadal mogą być potrzebne na koszty transakcji, opłaty i rezerwę, nawet gdy finansowanie obejmuje całą cenę zakupu.",
    sections: [
      { title: "Policz osobno cenę i pieniądze poza ceną", text: "Gwarancja uzupełnia wkład do 20% wydatków, lecz wynosi maksymalnie 100 000 zł. Z tego powodu przy wyższej cenie może być potrzebny własny wkład. Bank sprawdza także zdolność, cel zakupu oraz pozostałe warunki programu.", items: ["W standardowych przypadkach wkład pieniężny nie może przekroczyć 200 000 zł i 20% wydatków przy stopie zmiennej lub 30% przy stopie stałej przez co najmniej 5 lat.", "Przy gwarancji obowiązują osobne ograniczenia sumy wkładu i gwarancji. Działka oraz Premia Mieszkaniowa wymagają oddzielnej oceny zasad.", "Przy zakupie mieszkania trzeba sprawdzić właściwy limit ceny za m² oraz sytuację mieszkaniową gospodarstwa domowego."] },
      { title: "Uzgodnij wpłaty przed podpisaniem umowy", text: "Jeżeli sprzedający oczekuje wpłaty przed aktem, ustal jej rozliczenie w całym planie zakupu. Możliwość zwrotu wpłaty i finansowania ceny trzeba uzgodnić z bankiem i odpowiednio opisać w umowie. Nie zakładaj, że zwrot nastąpi automatycznie.", items: ["Zapisz cenę, kwotę wcześniejszej wpłaty i kwotę kredytu.", "Dodaj koszty zakupu, opłatę związaną z gwarancją oraz rezerwę.", "Sprawdź warunki programu i banku przed zobowiązaniem się do transakcji."] },
    ],
    example: { title: "Zakup za 600 000 zł z gwarancją BGK", text: "Przykład pokazuje mechanizm gwarancji. Nie potwierdza spełnienia wszystkich warunków programu.", rows: [["Cena mieszkania", "600 000 zł"], ["Twoje pieniądze na cenę", "20 000 zł"], ["Kwota kredytu do spłaty", "580 000 zł"], ["Gwarancja części tego kredytu", "100 000 zł"]], takeaway: "Gwarancja nie odejmuje 100 000 zł od długu. Spłacasz 580 000 zł. Koszty zakupu i rezerwę przygotowujesz osobno." },
    prepare: "Cena, lokalizacja i powierzchnia mieszkania, dostępne środki oraz podstawowa informacja o posiadanych nieruchomościach.", cta: "Sprawdźmy Twój wkład i możliwości", help: "Rozdzielimy wkład, gwarancję i koszty zakupu oraz sprawdzimy podstawowe warunki Twojego planu.",
    tools: [{ label: "Porównaj wkład i wariant RKM", href: "/kalkulator-rata-wklad" }, { label: "Przygotuj dokumenty zakupu", href: "/checklisty" }],
    faqs: [{ q: "Czy gwarancja zmniejsza kwotę kredytu?", a: "Nie. Jest zabezpieczeniem części kredytu, który spłacasz." }, { q: "Czy przy wkładzie 20% RKM zawsze odpada?", a: "Nie. RKM może być udzielony bez gwarancji, jeżeli spełnione są odpowiednie warunki. Przy stopie okresowo stałej przez co najmniej 5 lat standardowy limit procentowy wkładu jest inny niż przy stopie zmiennej." }],
    sources: [{ label: "BGK: zasady Rodzinnego Kredytu Mieszkaniowego", href: "https://www.bgk.pl/produkty/rodzinny-kredyt-mieszkaniowy/" }],
  },
  {
    slug: "refinansowanie-rata-a-oszczednosc", title: "Refinansowanie: kiedy niższa rata oznacza oszczędność?",
    description: "Porównaj kredyty na tym samym okresie i uwzględnij koszty przeniesienia, zanim ocenisz niższą ratę.",
    topic: "refinansowanie", icon: "credit",
    answer: "Niższa rata może wynikać z lepszych warunków albo z wydłużenia spłaty. Zacznij od porównania tego samego salda i pozostałego okresu, dodając koszty zmiany oraz produkty wymagane do uzyskania warunków. Osobno oceń, czy ważniejsza jest miesięczna płynność, czy łączny koszt.",
    sections: [
      { title: "Porównaj kredyty z takim samym okresem spłaty", text: "Zapisz obecne saldo, liczbę pozostałych rat, oprocentowanie i wymagane opłaty. Nowy kredyt policz najpierw na tym samym okresie. Wariant z dłuższą spłatą pokaż oddzielnie, aby widzieć cenę niższego miesięcznego obciążenia.", items: ["Uwzględnij wycenę, opłaty związane z zabezpieczeniem i prowizję, jeżeli występują.", "Sprawdź warunki wcześniejszej spłaty obecnego kredytu.", "Porównaj również ubezpieczenia, konto i inne wymagania utrzymania warunków."] },
      { title: "Kiedy niższe raty pokryją koszty przeniesienia?", text: "Podzielenie jednorazowych kosztów przez miesięczną różnicę obciążeń daje wstępny punkt odniesienia. To nie pełne wyliczenie oszczędności: w ratach może być inny udział kapitału i odsetek. Jeżeli oprocentowanie ma się zmieniać, porównaj także scenariusz po zakończeniu okresu stałej stopy.", items: ["Porównaj sumę przyszłych płatności i saldo na tym samym etapie spłaty.", "Uwzględnij planowane nadpłaty i czas, przez jaki zamierzasz utrzymać kredyt.", "Sprawdź, czy korzyść pozostaje po doliczeniu wszystkich znanych kosztów."] },
    ],
    example: { title: "200 zł mniej miesięcznie: kiedy pokryjesz koszty?", text: "Porównujesz takie samo saldo i okres spłaty. W tym uproszczonym przykładzie:", rows: [["Obecna rata i wymagane opłaty", "2 500 zł"], ["Nowa rata i wymagane opłaty", "2 300 zł"], ["Różnica miesięczna", "200 zł"], ["Jednorazowy koszt zmiany", "3 000 zł"]], takeaway: "3 000 zł ÷ 200 zł = 15 miesięcy. Po tym czasie niższe miesięczne płatności pokryją koszt zmiany, jeśli warunki pozostaną takie same. Pełne porównanie obejmuje także odsetki i pozostały dług." },
    prepare: "Aktualne saldo, liczba pozostałych rat, oprocentowanie i opłaty oraz planowane nadpłaty. Do pierwszej rozmowy wystarczy podsumowanie.", cta: "Porównajmy Twój obecny kredyt", help: "Sprawdzimy różnicę rat, okresu i kosztów zmiany, uwzględniając Twój plan spłaty.",
    tools: [{ label: "Zobacz narzędzia porównania kredytu", href: "/narzedzia/" }, { label: "Policz plan nadpłat", href: "/kalkulator-nadplat" }],
    faqs: [{ q: "Czy wydłużenie okresu jest zawsze złym rozwiązaniem?", a: "Nie. Może pomóc w miesięcznym budżecie, ale trzeba świadomie porównać łączny koszt i sposób dalszej spłaty." }, { q: "Czy nadpłata może być alternatywą dla przeniesienia?", a: "Tak, warto zestawić pozostanie w obecnym banku z nadpłatami oraz przeniesienie na nowych warunkach. Wynik zależy od umowy i dostępnych środków." }],
    sources: [{ label: "UOKiK: wcześniejsza spłata i warunki umowy", href: "https://finanse.uokik.gov.pl/kredyty-hipoteczne/ustawa-o-kredycie-hipotecznym/" }],
  },
  {
    slug: "pozyczka-hipoteczna-kiedy-rozwazyc", title: "Pożyczka hipoteczna: kiedy warto ją rozważyć?",
    description: "Porównaj kwotę, okres i wszystkie koszty finansowania z ustanowieniem hipoteki i bez niej.",
    topic: "pozyczka-hipoteczna", icon: "wallet",
    answer: "Pożyczkę hipoteczną warto porównać z innymi rozwiązaniami, gdy potrzebujesz większej kwoty i masz nieruchomość, którą bank może przyjąć jako zabezpieczenie. Oceń łączny koszt, okres i czas potrzebny na formalności. Sama niższa rata nie przesądza o lepszym rozwiązaniu.",
    sections: [
      { title: "Zacznij od kwoty i terminu", text: "Określ cel wydatku, potrzebną kwotę i termin, w którym pieniądze muszą być dostępne. Pożyczka hipoteczna oraz kredyt na zakup mieszkania mają inne zastosowanie. Możliwość finansowania konkretnego celu i warunki potwierdza bank.", items: ["Czy posiadasz nieruchomość i jakie ma obecne obciążenia?", "Czy potrzebujesz jednorazowej kwoty, czy finansowania etapami?", "Ile miesięcznie możesz spłacać, pozostawiając rezerwę?"] },
      { title: "Porównaj cenę niższej raty", text: "Dłuższy okres może zmniejszyć ratę, a jednocześnie zwiększyć sumę odsetek. Zestaw warianty na tym samym okresie, a następnie pokaż wariant wydłużony. Dodaj koszty wyceny, ustanowienia zabezpieczenia i wymaganych produktów.", items: ["Porównaj całkowitą kwotę do spłaty, a nie tylko oprocentowanie.", "Sprawdź możliwość wcześniejszej spłaty i koszty zmiany planu.", "Pamiętaj, że zabezpieczeniem jest nieruchomość. Brak spłaty może skutkować dochodzeniem należności z tego zabezpieczenia."] },
    ],
    example: { title: "Niższa rata, ale więcej do oddania", text: "Dwa przykładowe warianty finansowania 100 000 zł. Zakładamy stałe raty i brak dodatkowych opłat; to nie oferta banku.", rows: [["5 lat: 60 rat po 2 200 zł", "132 000 zł"], ["10 lat: 120 rat po 1 300 zł", "156 000 zł"], ["Różnica w sumie płatności", "24 000 zł"]], takeaway: "Drugi wariant daje ratę niższą o 900 zł, ale łącznie oddajesz o 24 000 zł więcej. Porównuj ratę razem z okresem i sumą spłat." },
    prepare: "Potrzebna kwota, cel i termin wydatku, oczekiwana rata oraz podstawowe informacje o nieruchomości i jej obciążeniach.", cta: "Porównaj możliwości finansowania", help: "Porównamy rozwiązania z hipoteką i bez niej, biorąc pod uwagę koszt, termin i Twój budżet.",
    tools: [{ label: "Poznaj pożyczkę hipoteczną", href: "/pozyczka-hipoteczna" }, { label: "Zobacz narzędzia finansowe", href: "/narzedzia/" }],
    faqs: [{ q: "Czy można z góry wskazać najlepszy wariant?", a: "Nie bez danych. Znaczenie mają kwota, okres, zdolność, nieruchomość i warunki konkretnej oferty." }, { q: "Czy niższa rata wystarczy do decyzji?", a: "Nie. Zestaw ją z sumą płatności, formalnościami, zabezpieczeniem i możliwością wcześniejszej spłaty." }],
  },
];

guides.push(...[
  {
    "slug": "co-sklada-sie-na-rate",
    "title": "Co składa się na ratę kredytu?",
    "description": "Oddziel spłatę długu, odsetki i dodatkowe opłaty.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Rata zwykle zawiera kapitał, czyli zwrot pożyczonych pieniędzy, oraz odsetki. Składka ubezpieczenia lub opłata za konto może być pobierana osobno. Dlatego rata nie zawsze pokazuje całe miesięczne obciążenie.",
    "sections": [
      {
        "title": "Sprawdź trzy pozycje",
        "text": "Zajrzyj do harmonogramu oraz listy opłat w ofercie.",
        "items": [
          "Ile z raty zmniejsza Twój dług?",
          "Ile stanowią odsetki?",
          "Jakie opłaty lub składki płacisz poza ratą?"
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Kapitał w przykładowej racie",
          "700 zł"
        ],
        [
          "Odsetki",
          "1 800 zł"
        ],
        [
          "Rata kredytu",
          "2 500 zł"
        ],
        [
          "Osobna składka",
          "100 zł"
        ]
      ],
      "takeaway": "Z konta ubywa 2 600 zł, ale dług zmniejsza się o 700 zł. To przykładowe kwoty, nie harmonogram konkretnego kredytu."
    },
    "prepare": "Orientacyjna kwota, okres spłaty i oferta banku, jeśli już ją masz.",
    "cta": "Nie musisz znać wszystkich pojęć",
    "help": "Wyjaśnimy warunki prostym językiem i odniesiemy je do Twojej sytuacji.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz orientacyjną ratę",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy ten przykład jest ofertą banku?",
        "a": "Nie. Pokazuje sposób myślenia. Warunki kredytu potwierdzamy dla konkretnej oferty i sytuacji."
      }
    ]
  },
  {
    "slug": "oprocentowanie-stale-zmienne",
    "title": "Stałe czy zmienne oprocentowanie?",
    "description": "Zobacz, co może zmieniać ratę i na jak długo ustalasz warunki.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Przy zmiennym oprocentowaniu rata może rosnąć lub spadać wraz ze wskaźnikiem wskazanym w umowie. Okresowo stałe oprocentowanie pozostaje ustalone przez określony czas; nie oznacza stałych warunków przez całe 25 czy 30 lat.",
    "sections": [
      {
        "title": "Sprawdź, na ile lat ustalasz oprocentowanie",
        "text": "Oprocentowanie okresowo stałe daje przewidywalność w ustalonym okresie, lecz nie korzystasz wtedy automatycznie ze spadku stóp.",
        "items": [
          "Sprawdź termin zakończenia ustalonego oprocentowania.",
          "Przeczytaj, jak bank ustali warunki po tym terminie.",
          "Porównaj budżet również dla wyższej raty przy wariancie zmiennym."
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Okres spłaty w przykładzie",
          "25 lat"
        ],
        [
          "Ustalona stopa w przykładzie",
          "5 lat"
        ]
      ],
      "takeaway": "Po 5 latach kredyt nadal trwa. Warunki dalszego oprocentowania wynikają z umowy; nie zakładaj utrzymania tej samej raty."
    },
    "prepare": "Orientacyjna kwota, okres spłaty i oferta banku, jeśli już ją masz.",
    "cta": "Nie musisz znać wszystkich pojęć",
    "help": "Wyjaśnimy warunki prostym językiem i odniesiemy je do Twojej sytuacji.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz orientacyjną ratę",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy ten przykład jest ofertą banku?",
        "a": "Nie. Pokazuje sposób myślenia. Warunki kredytu potwierdzamy dla konkretnej oferty i sytuacji."
      }
    ]
  },
  {
    "slug": "marza-banku",
    "title": "Marża banku: co oznacza dla Twojego kredytu?",
    "description": "Poznaj różnicę między marżą a całym oprocentowaniem.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "W kredycie ze zmiennym oprocentowaniem marża jest składnikiem dodawanym do wskaźnika referencyjnego. Sama marża nie pokazuje całego oprocentowania ani wszystkich kosztów.",
    "sections": [
      {
        "title": "Sprawdź warunki utrzymania marży",
        "text": "Oferta może uzależniać marżę od określonych produktów lub obowiązków. Porównaj koszt ich utrzymania.",
        "items": [
          "Znajdź marżę i wskaźnik w formularzu informacyjnym.",
          "Sprawdź, kiedy marża może się zmienić zgodnie z umową.",
          "Dolicz wymagane opłaty i ubezpieczenia."
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Przykładowy wskaźnik",
          "4%"
        ],
        [
          "Przykładowa marża",
          "2%"
        ],
        [
          "Oprocentowanie",
          "6%"
        ]
      ],
      "takeaway": "Jeżeli wskaźnik wzrośnie do 5%, przy niezmienionej marży oprocentowanie wyniesie 7%. To przykład mechanizmu, nie aktualna oferta."
    },
    "prepare": "Orientacyjna kwota, okres spłaty i oferta banku, jeśli już ją masz.",
    "cta": "Nie musisz znać wszystkich pojęć",
    "help": "Wyjaśnimy warunki prostym językiem i odniesiemy je do Twojej sytuacji.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz orientacyjną ratę",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy ten przykład jest ofertą banku?",
        "a": "Nie. Pokazuje sposób myślenia. Warunki kredytu potwierdzamy dla konkretnej oferty i sytuacji."
      }
    ]
  },
  {
    "slug": "wibor-polstr",
    "title": "WIBOR i POLSTR: co oznaczają dla raty?",
    "description": "Wyjaśniamy wskaźniki bez obietnic tańszego kredytu.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Wskaźnik referencyjny jest elementem ustalania zmiennego oprocentowania. WIBOR i POLSTR są różnymi wskaźnikami. POLSTR jest wdrażany w ramach reformy rynku; zmiana nazwy nie oznacza automatycznie niższej raty.",
    "sections": [
      {
        "title": "Sprawdź swoją umowę",
        "text": "Znaczenie mają sposób obliczania oprocentowania, aktualizacji oraz ewentualnej zmiany wskaźnika. Nie wystarczy porównać dwóch wartości z jednego dnia.",
        "items": [
          "Ustal, jaki wskaźnik i jego wariant wskazuje umowa.",
          "Sprawdź terminy aktualizacji oprocentowania.",
          "Zapytaj bank o zasady zastąpienia wskaźnika."
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Elementy do porównania",
          "wskaźnik + marża"
        ],
        [
          "Dodatkowo",
          "zasady umowy"
        ]
      ],
      "takeaway": "Dwie oferty z różnymi wskaźnikami porównuj razem z marżą i kosztami. Nie zakładaj automatycznej zmiany istniejącej umowy. Według komunikatów KNF z 2026 r. od początku 2027 r. WIBOR nie powinien być stosowany w nowych umowach; istniejące umowy mogą nadal go wykorzystywać w okresie przejściowym."
    },
    "prepare": "Orientacyjna kwota, okres spłaty i oferta banku, jeśli już ją masz.",
    "cta": "Nie musisz znać wszystkich pojęć",
    "help": "Wyjaśnimy warunki prostym językiem i odniesiemy je do Twojej sytuacji.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz orientacyjną ratę",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy ten przykład jest ofertą banku?",
        "a": "Nie. Pokazuje sposób myślenia. Warunki kredytu potwierdzamy dla konkretnej oferty i sytuacji."
      }
    ]
  },
  {
    "slug": "rrso-a-oprocentowanie",
    "title": "RRSO a oprocentowanie: jaka jest różnica?",
    "description": "Dlaczego jedna liczba nie wystarcza do porównania ofert?",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Oprocentowanie służy do naliczania odsetek. RRSO pokazuje roczny koszt kredytu w procentach, uwzględniając odsetki i koszty objęte obliczeniem. Nie jest prostą sumą oprocentowania i prowizji.",
    "sections": [
      {
        "title": "Porównuj takie same założenia",
        "text": "RRSO pomaga porównywać oferty, ale sprawdź także kwotę, okres, harmonogram oraz wymagane produkty.",
        "items": [
          "Poproś o formularz informacyjny dla tej samej kwoty i okresu.",
          "Sprawdź prowizję, ubezpieczenia i inne wymagane koszty.",
          "Porównaj całkowitą kwotę do zapłaty i koszty poza RRSO."
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Oprocentowanie dotyczy",
          "odsetek"
        ],
        [
          "RRSO dotyczy",
          "kosztu w skali roku"
        ]
      ],
      "takeaway": "Dwie oferty z takim samym oprocentowaniem mogą mieć różne prowizje i wymagane opłaty. Nie wybieraj wyłącznie na podstawie oprocentowania."
    },
    "prepare": "Orientacyjna kwota, okres spłaty i oferta banku, jeśli już ją masz.",
    "cta": "Nie musisz znać wszystkich pojęć",
    "help": "Wyjaśnimy warunki prostym językiem i odniesiemy je do Twojej sytuacji.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz orientacyjną ratę",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy ten przykład jest ofertą banku?",
        "a": "Nie. Pokazuje sposób myślenia. Warunki kredytu potwierdzamy dla konkretnej oferty i sytuacji."
      }
    ]
  },
  {
    "slug": "wklad-i-koszty-zakupu",
    "title": "Wkład własny: co przygotować poza ceną mieszkania?",
    "description": "Oddziel wkład, koszty transakcji i pieniądze na późniejsze wydatki.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Wkład własny to Twoja część finansowania zakupu uznana przez bank. Poza nim mogą być potrzebne pieniądze na koszty transakcji, remont i rezerwę. Wymagany wkład zależy od banku i wariantu finansowania.",
    "sections": [
      {
        "title": "Zrób trzy oddzielne listy",
        "text": "Nie przeznaczaj całej dostępnej gotówki wyłącznie na wkład.",
        "items": [
          "Ustal kwotę wkładu w wybranym wariancie.",
          "Dodaj opłaty i wydatki związane z zakupem.",
          "Zostaw rezerwę na przeprowadzkę i nieprzewidziane wydatki."
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Przykładowy wkład",
          "50 000 zł"
        ],
        [
          "Koszty zakupu",
          "15 000 zł"
        ],
        [
          "Rezerwa",
          "20 000 zł"
        ],
        [
          "Razem",
          "85 000 zł"
        ]
      ],
      "takeaway": "Posiadanie 50 000 zł wkładu nie oznacza, że wystarczy Ci pieniędzy na cały plan. Podane koszty są przykładowe."
    },
    "prepare": "Orientacyjna kwota, okres spłaty i oferta banku, jeśli już ją masz.",
    "cta": "Nie musisz znać wszystkich pojęć",
    "help": "Wyjaśnimy warunki prostym językiem i odniesiemy je do Twojej sytuacji.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz orientacyjną ratę",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy ten przykład jest ofertą banku?",
        "a": "Nie. Pokazuje sposób myślenia. Warunki kredytu potwierdzamy dla konkretnej oferty i sytuacji."
      }
    ]
  }
]);

// Editorial verification: KNF Rekomendacja S; PKO BP information on fixed base rate + margin.
const fixedGuide=guides.find(g=>g.slug==="oprocentowanie-stale-zmienne");
Object.assign(fixedGuide, {
  answer:"Przy oprocentowaniu zmiennym jego wysokość może wzrosnąć lub spaść w terminach zapisanych w umowie. Przy okresowo stałym ustalasz oprocentowanie na określony czas, na przykład 5 lat. Zmiana rynkowych stóp nie zmienia go w tym okresie. Po jego zakończeniu ustalasz dalsze warunki zgodnie z umową.",
  example:{title:"Ta sama kwota, inna reakcja na zmianę stóp",text:"Przykładowy kredyt 300 000 zł na 25 lat, raty równe. Porównujemy oprocentowanie 6% i scenariusz 7% przy tym samym saldzie i okresie; bez opłat dodatkowych.",rows:[["Przy oprocentowaniu 6%","ok. 1 933 zł"],["Przy oprocentowaniu 7%","ok. 2 120 zł"]],takeaway:"W wariancie zmiennym wzrost oprocentowania może podnieść ratę. Jeżeli masz ustalone 6% na 5 lat, sam wzrost stóp rynkowych nie zmieni tych 6% w tym okresie. Nie jest to prognoza przyszłej raty po 5 latach."}
});
const marginGuide=guides.find(g=>g.slug==="marza-banku");
Object.assign(marginGuide,{
  answer:"Marża jest elementem ceny kredytu banku. Może występować zarówno przy oprocentowaniu zmiennym, jak i okresowo stałym. Przy zmiennym bank zwykle dodaje ją do wskaźnika referencyjnego. Przy okresowo stałym może dodawać ją do stałej stopy bazowej ustalonej na dany okres. Sposób przedstawienia ceny sprawdź w konkretnej ofercie.",
  example:{title:"Marża występuje w obu wariantach",text:"Uproszczone liczby pokazują składniki oprocentowania, nie aktualną ofertę:",rows:[["Zmienna: wskaźnik 4% + marża 2%","6%"],["Stała: stała stopa bazowa 4% + marża 2%","6%"]],takeaway:"Przy zmiennym wzrost wskaźnika do 5% daje 7%, jeśli marża pozostaje 2%. Przy ustalonej stopie bazowej 4% sam wzrost bieżącego WIBOR lub POLSTR nie zmienia oprocentowania w ustalonym okresie. Stała stopa bazowa nie jest tym samym co aktualizowany wskaźnik zmienny."}
});
const indexGuide=guides.find(g=>g.slug==="wibor-polstr");
Object.assign(indexGuide,{
  answer:"Pomyśl o zmiennym oprocentowaniu jak o dwóch częściach: zmiennej wartości rynkowej i marży banku. WIBOR albo odpowiedni indeks oparty na POLSTR może być tą pierwszą częścią. Gdy jej wartość się zmienia, bank aktualizuje oprocentowanie według zasad umowy. Same skróty nie mówią, ile zapłacisz.",
  sections:[{title:"Co sprawdzić w swojej ofercie?",text:"WIBOR i POLSTR są wyznaczane w różny sposób. POLSTR opiera się na krótkoterminowych transakcjach depozytowych; w umowach mogą być stosowane indeksy składane oparte na POLSTR. Reforma nie oznacza, że wszystkie istniejące kredyty zmieniają się od razu.",items:["Jaki dokładnie wskaźnik lub indeks wskazuje umowa?", "Jak często i za jaki okres bank ustala jego wartość?", "Jaka marża jest dodawana i jakie są zasady zmiany wskaźnika?"]}],
  example:{title:"Najpierw zobacz wpływ na oprocentowanie",text:"To prosty przykład działania zmiennego oprocentowania, bez przypisywania wartości do konkretnego wskaźnika:",rows:[["Wartość wskaźnika 4% + marża 2%","6%"],["Wartość wskaźnika 5% + marża 2%","7%"]],takeaway:"Zmieniła się część rynkowa, więc oprocentowanie wzrosło o 1 punkt procentowy. Rata nie rośnie o ten sam procent: zależy także od długu i okresu spłaty. WIBOR i POLSTR porównuj razem z zasadami naliczania, marżą oraz kosztami."}
});

guides.push(...[
  {
    "slug": "zdolnosc-kredytowa",
    "title": "Zdolność kredytowa: ile możesz pożyczyć?",
    "description": "Sprawdź, co bank ocenia i dlaczego maksymalna kwota nie musi być Twoim celem.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Zdolność kredytowa to ocena możliwości spłaty kredytu wraz z odsetkami. Bank uwzględnia dochody, wydatki, zobowiązania i okres. Różne banki mogą inaczej ocenić te same dane. Maksymalny kredyt to nie to samo co rata wygodna dla Twojego budżetu.",
    "sections": [
      {
        "title": "Przygotuj dane do wstępnej analizy",
        "text": "Zacznij od swojej sytuacji i warunków konkretnej oferty.",
        "items": [
          "Dochody: źródło, wysokość i stabilność.",
          "Wydatki gospodarstwa domowego i liczba osób na utrzymaniu.",
          "Raty, karty, limity, alimenty i inne stałe zobowiązania."
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Dochód rodziny w przykładzie",
          "8 000 zł"
        ],
        [
          "Wydatki i obecne zobowiązania",
          "5 000 zł"
        ],
        [
          "Pozostaje przed nową ratą",
          "3 000 zł"
        ]
      ],
      "takeaway": "3 000 zł nie jest wyliczoną zdolnością ani bezpieczną ratą. Bank stosuje własną ocenę, a Ty potrzebujesz także rezerwy. To punkt wyjścia do rozmowy."
    },
    "prepare": "Orientacyjna kwota, własne środki, dochody i obecne zobowiązania. Wystarczy podsumowanie bez dokumentów wrażliwych.",
    "cta": "Wyjaśnimy to na Twoim przykładzie",
    "help": "Połączymy informacje z Twoim planem i wskażemy kolejny krok.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz ratę i wkład",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy przykład jest ofertą lub decyzją banku?",
        "a": "Nie. Pomaga zrozumieć temat. Warunki oraz możliwości finansowania potwierdzamy dla konkretnej sytuacji."
      }
    ]
  },
  {
    "slug": "koszty-kredytu",
    "title": "Koszty kredytu: co zapłacisz poza ratą?",
    "description": "Prowizja, wycena, ubezpieczenia i wymagane produkty w jednym planie.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Oddziel koszty jednorazowe od cyklicznych. Poza odsetkami mogą wystąpić prowizja, wycena, opłaty dotyczące zabezpieczenia, ubezpieczenia oraz wymagane produkty. Ich wysokość i czas obowiązywania zależą od oferty.",
    "sections": [
      {
        "title": "Poproś o pełną listę kosztów",
        "text": "Zacznij od swojej sytuacji i warunków konkretnej oferty.",
        "items": [
          "Jednorazowo: prowizja, wycena, opłaty ustanowienia zabezpieczenia.",
          "Co miesiąc lub rok: wymagane ubezpieczenia i produkty.",
          "Przy zmianie planu: ewentualny koszt wcześniejszej spłaty lub aneksu."
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Przykładowa prowizja",
          "0 zł"
        ],
        [
          "Przykładowa wycena",
          "800 zł"
        ],
        [
          "Przykładowa składka miesięczna",
          "100 zł"
        ]
      ],
      "takeaway": "Prowizja 0 zł nie oznacza kredytu bez innych kosztów. Wycena to wydatek jednorazowy; składka 100 zł miesięcznie daje 1 200 zł w roku. Podane kwoty są przykładowe."
    },
    "prepare": "Orientacyjna kwota, własne środki, dochody i obecne zobowiązania. Wystarczy podsumowanie bez dokumentów wrażliwych.",
    "cta": "Wyjaśnimy to na Twoim przykładzie",
    "help": "Połączymy informacje z Twoim planem i wskażemy kolejny krok.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz ratę i wkład",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy przykład jest ofertą lub decyzją banku?",
        "a": "Nie. Pomaga zrozumieć temat. Warunki oraz możliwości finansowania potwierdzamy dla konkretnej sytuacji."
      }
    ]
  },
  {
    "slug": "ubezpieczenia-przy-kredycie",
    "title": "Ubezpieczenia przy kredycie: co warto sprawdzić?",
    "description": "Oddziel ochronę nieruchomości, życia i wymagania banku.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Ubezpieczenie nieruchomości i ubezpieczenie na życie mają różne zadania. Sprawdź, czy polisa jest warunkiem kredytu lub ceny, kto otrzyma świadczenie i co obejmuje umowa. Nie porównuj wyłącznie składek.",
    "sections": [
      {
        "title": "Sprawdź zakres i czas opłacania",
        "text": "Zacznij od swojej sytuacji i warunków konkretnej oferty.",
        "items": [
          "Jaka suma, zdarzenia i wyłączenia obowiązują?",
          "Przez jaki czas bank wymaga polisy lub uzależnia od niej cenę?",
          "Czy możesz wybrać polisę zewnętrzną i jakie warunki musi spełnić?"
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Polisa nieruchomości",
          "chroni wskazany majątek"
        ],
        [
          "Polisa na życie",
          "świadczenie przy zdarzeniu z umowy"
        ]
      ],
      "takeaway": "Polisa wymagana przez bank nie musi zapewniać całej ochrony potrzebnej rodzinie. Porównaj zakres, sumę i warunki wypłaty."
    },
    "prepare": "Orientacyjna kwota, własne środki, dochody i obecne zobowiązania. Wystarczy podsumowanie bez dokumentów wrażliwych.",
    "cta": "Wyjaśnimy to na Twoim przykładzie",
    "help": "Połączymy informacje z Twoim planem i wskażemy kolejny krok.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz ratę i wkład",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy przykład jest ofertą lub decyzją banku?",
        "a": "Nie. Pomaga zrozumieć temat. Warunki oraz możliwości finansowania potwierdzamy dla konkretnej sytuacji."
      }
    ]
  },
  {
    "slug": "raty-rowne-malejace",
    "title": "Raty równe czy malejące?",
    "description": "Zobacz, jak zmienia się spłata kapitału i obciążenie na początku.",
    "topic": "zakup-wtorny",
    "icon": "wallet",
    "group": "basics",
    "answer": "Przy ratach równych spłata kapitału i odsetek jest rozłożona tak, by przy niezmiennym oprocentowaniu rata była zbliżona. Przy malejących część kapitałowa jest stała, a odsetki naliczane od zmniejszającego się długu. Zwykle oznacza to większe obciążenie na początku.",
    "sections": [
      {
        "title": "Porównaj pierwszy rok i całkowity koszt",
        "text": "Zacznij od swojej sytuacji i warunków konkretnej oferty.",
        "items": [
          "Ustal taką samą kwotę, okres i oprocentowanie.",
          "Sprawdź, czy początkowe raty mieszczą się w budżecie.",
          "Porównaj odsetki i własny plan nadpłat."
        ]
      }
    ],
    "example": {
      "title": "Prosty przykład",
      "text": "Spójrz na te pozycje osobno:",
      "rows": [
        [
          "Raty równe",
          "bardziej wyrównane obciążenie"
        ],
        [
          "Raty malejące",
          "wyższe na początku"
        ]
      ],
      "takeaway": "Przy zmiennym oprocentowaniu także rata nazywana równą może się zmieniać. Porównaj oba warianty w kalkulatorze dla swoich założeń."
    },
    "prepare": "Orientacyjna kwota, własne środki, dochody i obecne zobowiązania. Wystarczy podsumowanie bez dokumentów wrażliwych.",
    "cta": "Wyjaśnimy to na Twoim przykładzie",
    "help": "Połączymy informacje z Twoim planem i wskażemy kolejny krok.",
    "contactLabel": "Porozmawiajmy o Twoim kredycie",
    "tools": [
      {
        "label": "Policz ratę i wkład",
        "href": "/kalkulator-rata-wklad"
      },
      {
        "label": "Zobacz checklisty",
        "href": "/checklisty"
      }
    ],
    "faqs": [
      {
        "q": "Czy przykład jest ofertą lub decyzją banku?",
        "a": "Nie. Pomaga zrozumieć temat. Warunki oraz możliwości finansowania potwierdzamy dla konkretnej sytuacji."
      }
    ]
  }
]);
// One comparison per example; fixed-rate construction explained separately.
Object.assign(marginGuide, {
  description:"Zobacz, jak marża wpływa na oprocentowanie i co porównać w ofercie.",
  example:{title:"Dwa banki, ten sam wskaźnik, różne marże",text:"Porównujemy wyłącznie oprocentowanie zmienne. W obu przykładach wartość tego samego wskaźnika wynosi 4%.",rows:[["Bank A: 4% + marża 2%","6%"],["Bank B: 4% + marża 1,5%","5,5%"]],takeaway:"W banku B marża jest niższa o 0,5 punktu procentowego, więc oprocentowanie też jest niższe o 0,5 punktu. To jeszcze nie porównanie całego kosztu: sprawdź również prowizję, ubezpieczenia i wymagane produkty. Liczby są przykładowe."},
});
marginGuide.sections.push({title:"A przy oprocentowaniu stałym?",text:"Bank może podawać cenę jako stałą stopę bazową plus marżę. Stała stopa bazowa zostaje ustalona na określony okres, np. 5 lat. Nie zmienia się w tym okresie wraz z bieżącym WIBOR lub POLSTR. W innych ofertach bank pokazuje jedną łączną stawkę; sprawdź zapis konkretnej oferty.",items:["Porównaj całe oprocentowanie, a nie samą marżę.","Sprawdź, na ile lat ustalasz stawkę.","Przeczytaj zasady dalszego oprocentowania po tym okresie."]});
export default guides;
